angular
  .module('GlobalControllers')

  .filter('to_trusted', [
    '$sce',
    function($sce) {
      return function(text, type = 'html') {
        if (type === 'html') {
          return $sce.trustAsHtml(text);
        } else if (type === 'url') {
          return $sce.trustAsUrl(text);
        } else if (type === 'resourceUrl') {
          return $sce.trustAsResourceUrl(text);
        } else if (type === 'css') {
          return $sce.trustAsCss(text);
        } else if (type === 'js') {
          return $sce.trustAsJs(text);
        } else {
          return $sce.trustAs(type, text);
        }
      };
    }
  ])

  .filter('get_pluralize', [
    function() {
      return function(prefix, count) {
        if (count === 0) {
          return prefix + '.zero';
        } else if (count === 1) {
          return prefix + '.one';
        }
        return prefix + '.others';
      };
    }
  ])
  .filter('interpret_images', [
    function() {
      return function(text, level) {
        if (
          text.endsWith('.jpg') ||
          text.endsWith('.jpeg') ||
          text.endsWith('.png') ||
          text.endsWith('.gif')
        ) {
          return (
            '<img height="128" src="/media/delf/' +
            level.toLowerCase() +
            '/images/' +
            text +
            '" />'
          );
        }

        return text;
      };
    }
  ]);
